<style lang="scss" scoped>
@import "$vars";

.content-block {
  margin: 30px auto 60px;
  text-align: center;

  .btn-send {
    margin-top: 40px;
  }
  .display-message {
    margin-top: 40px;
  }
}

h3 {
  color: #4a4a4a;
  font-family: $base-font-family;
  font-size: 24px;
  font-weight: 600;
}

.align-center {
  align-items: center;
  justify-content: center;
}

.mgn-top-0 {
  margin-top: 0 !important;
}

</style>

<template>
  <main class="component-patients">
    <h3 class="text-center">Consulta encerrada com sucesso!</h3>
    <div class="content-block">

      <p class="display-message">
        Os documentos médicos gerados nesse atendimento, como prescrições médicas, atestados, pedidos de exames e documentos anexados, foram enviados para o e-mail do paciente.

        <template v-if="agenda.hasMedicalConsultationReturn">
          <br><br>
          Além disso, esse paciente receberá por e-mail um link para o agendamento automatizado do retorno e terá 30 dias para agendar o retorno, diretamente pela plataforma Dr. Conecta.
        </template>
      </p>

      <div class="d-flex flex-middle align-center">
        <dr-submit class="btn-send mgn-top-0" text="Ir para agenda" @click="$router.push({ name: 'DoctorAgenda' })"></dr-submit>
      </div>
    </div>
  </main>
</template>

<script>
import drSubmit from '@/components/form/submit.vue'
export default {
  props: ['agenda_id', 'isMedicalHistoryVisible', 'agenda'],
  components: {drSubmit}
}
</script>
